var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.enabled),expression:"enabled"}],staticClass:"busy-overlay"},[(_vm.loading)?_c('div',{staticClass:"loading message"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_c('div',{staticClass:"message"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }